<app-spinner [isLoading]="isLoading"></app-spinner>
<p-toast></p-toast>

<p-card class="user-card">
  <ng-template pTemplate="header">
    <div class="card-header">
      <span class="btn-groups">
        <button pButton type="button" icon="pi pi-arrow-left" class="p-button-text p-button-sm top-nav-btn"
          (click)="goBack()" [pTooltip]="'Click to go back'">
        </button>
        <button pButton type="button" icon="pi pi-refresh" class="p-button-text p-button-sm btn-reload top-nav-btn"
          (click)="reLoad(true)" [pTooltip]="'Reload this list'">
        </button>
        <button pButton type="button" icon="pi pi-download" class="p-button-text p-button-sm top-nav-btn"
          (click)="exportUsers()" [pTooltip]="'Export users to Excel'">
        </button>
        <!-- <button pButton type="button" label="Export" class="export-btn" (click)="exportUsers()">
        </button> -->
      </span>

      <span class="title">Users({{dt.filteredValue ? dt.filteredValue.length :totalCount}}) </span>
    </div>
  </ng-template>
  <p-table #dt [value]="users" [paginator]="true" [rows]="rowCount" [rowsPerPageOptions]="[5,10,20]" responsiveLayout="scroll"
    sortMode="multiple" stripedRows [multiSortMeta]="multiSortMeta"
    [globalFilterFields]="['userName']">

    <!-- Header -->
    <ng-template pTemplate="header">
      <tr style="height: 3rem;">
        <th class="avatar-col"></th>
        <th pSortableColumn="userName" class="name-col-header">
          Email <!--<p-sortIcon field="userName"></p-sortIcon> -->
        </th>
        <th pSortableColumn="lastLoginAt" style="text-align: center;" class="name-col-header">
          Last Login <p-sortIcon field="lastLoginAt"></p-sortIcon>
        </th>
        <th style="text-align: center;" pSortableColumn="isActive">Status <p-sortIcon field="isActive"></p-sortIcon>
      </th>
    </tr>

    <tr>
      <th class="avatar-col"></th>
      <th class="name-filter-col">
        <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
          placeholder="Search by Email" #filterInput />
          <span class="p-input-icon-left p-input-icon-right">@if (filterInput.value) {
            <i
              class="pi pi-times cursor-pointer" (click)="filterInput.value=''; dt.filterGlobal('', 'contains')" ;>
            </i>
          }</span>


        </th>

        <th></th>
        <th class="status-filter-col">
          <p-columnFilter field="isActive" matchMode="equals" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-select class="status-select" [ngModel]="value" [options]="statuses" (onChange)="filter($event.value)"
                placeholder="Select status" [showClear]="true" appendTo="body">
                <ng-template let-option pTemplate="item">
                  <span>{{option.label}}</span>
                </ng-template>
              </p-select>
            </ng-template>
          </p-columnFilter>
        </th>

      </tr>
    </ng-template>

    <!-- Body -->
    <ng-template pTemplate="body" let-user>
      <tr [class.stale-user-row]="user.isStale">
        <!-- Name with avatar -->
        <td class="avatar-col">
          <p-avatar [label]="(user.userName?.charAt(0)).toUpperCase()" shape="circle" styleClass="user-avatar">
          </p-avatar>
        </td>
        <td class="name-cell">
          <div class="user-info">

            <span class="user-name-text">{{ user.userName }}</span>
          </div>
        </td>

        <!-- Email -->
        <td style="text-align: center;">{{ user.lastLoginAt | date: 'dd-MM-yyyy HH:mm:ss'}}</td>

        <td class="status-cell" style="text-align: center;">
          <div class="toggle-wrapper">
            <p-toggleswitch [(ngModel)]="user.isActive">
                <ng-template #handle let-checked="checked">
                    @if (checked) {
                <i class="pi pi-check text-xs"></i>
                    } @else {
                <i class="pi pi-times text-xs"></i>
                    }
                </ng-template>
            </p-toggleswitch>

          </div>
        </td>

      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td colspan="5" style="text-align: center;"> <strong>No records found.</strong></td>
      </tr>
    </ng-template>
  </p-table>
  <div class="mt-3 text-right">
    <button pButton class="button-bg" label="Submit" icon="pi pi-check" (click)="onSubmit()" [disabled]="!hasChanged()">
    </button>
  </div>
</p-card>
<div class="summar-list-dialog">
  <p-dialog header="Changed User Summary" [(visible)]="showSummary" [modal]="true" [closable]="false"
    [style]="{ width: '420px' }" >

    <!-- Summary -->
    <div class="summary-counts">
      <div><b>Total Changed:</b> {{ changedUsers.length }}
      <b>Activated:</b> {{ activeCount }}
      <b>Deactivated:</b> {{ inactiveCount }}
    </div>
  </div>

  <p-divider></p-divider>

  <!-- Lined detail list -->
  <div class="user-list">
    @for (user of changedUsers; track user) {
      <div class="user-row">
        <span class="email">{{ user.userName }}</span>
        <span class="status" [ngClass]="user.isActive ? 'active' : 'inactive'">
          {{ user.isActive ? 'Active' : 'Inactive' }}
        </span>
      </div>
    }
  </div>

  <p-divider></p-divider>

  <!-- Footer buttons -->
  <div class="dialog-footer">
    <button pButton label="Cancel" class="p-button-text btn-cancel" (click)="closeDialog()">
    </button>

    <button pButton label="Submit" icon="pi pi-check" class="p-button-success" (click)="confirmSubmit()">
    </button>
  </div>

</p-dialog>
</div>
